import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { SprayEventForSubmission } from 'services/sprayEventsForSubmission/types';
import { makeSelectEntityNames } from './selectors';

export interface OwnProps {
    sprayEventId: SprayEventForSubmission['id'];
}

interface ConnectedProps {
    entityNames?: string;
}

type Props = OwnProps & ConnectedProps;

export class RenderSubmissionSprayEventsTableRowEntitiesCellComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { entityNames } = this.props;

        return (
            <TableCell textAlign="left" className="events-table-cell-padding">
                {entityNames}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityNames: makeSelectEntityNames()
});

export default connect(mapStateToProps)(
    RenderSubmissionSprayEventsTableRowEntitiesCellComponent
);
